import type { RefObject } from 'react';
import { Heading } from '../../tokens';
import { ReactComponent as CheckmarkIcon } from '../../../assets/shared/ic-shared-checkmark.svg';
import type { Suggestion } from './LiliAsyncAutoComplete';

interface ItemTemplateProps {
  item: Suggestion;
  isSelected: boolean;
  isLastItem: boolean;
  isFirstItem: boolean;
  firstItemRef: RefObject<HTMLDivElement | null>;
  lastItemRef: RefObject<HTMLDivElement | null>;
  setSearchValue: (value: string) => void;
  onSelect: (suggestion: Suggestion) => void;
  getSelectDisplayTitle?: (suggestion: Suggestion) => string;
}

export const ItemTemplate = ({
  item,
  isSelected,
  isLastItem,
  isFirstItem,
  firstItemRef,
  lastItemRef,
  setSearchValue,
  onSelect,
  getSelectDisplayTitle,
}: ItemTemplateProps) => {
  return (
    <div
      id={item.value}
      ref={isFirstItem ? firstItemRef : isLastItem ? lastItemRef : null}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => {
        setSearchValue(getSelectDisplayTitle ? getSelectDisplayTitle(item) : item.title);
        onSelect?.(item);
      }}
      className='flex items-center min-h-[42px] py-[4px] px-[8px] border-b border-outline-primary-bw-03'>
      <div
        className={`${
          isSelected
            ? 'bg-surface-brand-action-00 text-text-brand-primary'
            : 'hover:bg-surface-primary-bw-02'
        } w-full px-[8px] py-[6px] rounded-[4px] cursor-pointer duration-100 flex items-center justify-between`}>
        <Heading.H10
          className={`max-w-full break-words ${isSelected ? 'text-text-brand-primary' : 'text-text-main-secondary'}`}>
          {item.title}
        </Heading.H10>
        {isSelected && <CheckmarkIcon className='text-text-brand-primary w-[20px] h-[20px]' />}
      </div>
    </div>
  );
};
